// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__274gv","active":"NavigationItem_active__3TaJJ","Clickable":"NavigationItem_Clickable__3RBXZ","Info":"NavigationItem_Info__Gv4Oe"};